import {
  LOADING_REFERENCES,
  RECEIVED_REFERENCES,
  RECEIVED_REFERENCES_FAILED,
  OPEN_REFERENCE,
} from '../../actions/types';

export default function references(state = {}, action = {}) {
  switch (action.type) {
    case (LOADING_REFERENCES):
      return {
        ...state,
        isLoading: true,
        rangeIndex: 0,
      };
    case (RECEIVED_REFERENCES):
      return {
        ...state,
        isLoading: false,
        data: action.payload,
        rangeIndex: 0,
      };
    case (RECEIVED_REFERENCES_FAILED):
      return {
        ...state,
        isLoading: false,
        failed: true,
        rangeIndex: 0,
      };
    case OPEN_REFERENCE:
      return {
        ...state,
        ...action.payload,
        rangeIndex: action.payload.rangeIndex || 0, // always set 0
      };
    default:
      return state;
  }
}
